import styled from 'styled-components'

export default styled.div`
  visibility: ${props => props.visible ? 'visible' : 'hidden'};
  color: #ce3f55;
`
